// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { viewSelectStyles } from "@awc/Overrides/Widgets/ProductList/ProductListTableViewFilter";
import IconPlpTableColumns from "@awc/XDL/Icons/IconPlpTableColumns";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color } from "@awc/XDL/Utilities";
import { css } from "styled-components";

viewSelectStyles.wrapper = {};

viewSelectStyles.tagClickable = {
    css: css`
        display: flex;
        gap: 8px;
        padding: 10px 12px;
        background-color: ${color("common.ui2")};
        align-items: flex-start;
    `,
};

viewSelectStyles.tagIcon = {
    src: IconPlpTableColumns,
    size: 13,
    css: css`
        width: 19px;
        svg {
            width: 19px;
            height: 14px;
        }
    `,
};

viewSelectStyles.columnsButtonLabel = {
    size: fontConfig.fontSize.xSmall,
    lineHeight: fontConfig.lineHeight.singleLinexSmall,
    weight: fontConfig.weight.bold,
};
